import { CloseLight } from '@ha/icons';
import React from 'react';
import cx from 'classnames';
import { WithStyles, Theme, createStyles, withStyles } from '@material-ui/core';

import { IconButton, units } from '@ha/dsl';

export const styles = (theme: Theme) =>
  createStyles({
    common: {
      stroke: theme.palette.grey[500],
      strokeWidth: '3px',
      fontSize: '14px',
    },
    button: {
      padding: '8px',
    },
    default: {
      position: 'absolute',
      top: 0,
      right: 0,
    },
    fixed: {
      position: 'relative',
    },
    mobileMap: {
      position: 'absolute',
      top: units.rem(0.75),
      left: units.rem(0.75),
    },
    'bg-mobileMap': {
      backgroundColor: 'white',
    },
  });

export type Kind = 'default' | 'fixed' | 'mobileMap';

interface Props {
  kind?: Kind;
  onClose: () => void;
}
const CloseBtn: React.FC<Props & WithStyles<typeof styles>> = ({
  onClose,
  classes,
  kind = 'default',
}) => (
  <div className={classes[kind]}>
    <IconButton
      onClick={onClose}
      className={cx(classes.button, classes[`bg-${kind}`])}
      data-test-locator="Modal Close Button"
    >
      <CloseLight className={cx(classes.common, classes[`icon-${kind}`])} />
    </IconButton>
  </div>
);

export default withStyles(styles)(CloseBtn);
